window.closeDialogAndReload = function(){
  ajaxDialog('close');
  if (typeof ListBewaesserungssystem !== 'undefined') {
    ListBewaesserungssystem.updater();
  } else {
    location.reload();
  }
}